import { Handle, type NodeProps, Position } from "@xyflow/react";
import { ArrowUpToLine } from "lucide-react";

import { Button } from "@/components/ui/button";
import { StatusBadge } from "../status-badge";
import type { StageNodeType } from "./layout.ts";

export function StageNode({ data }: NodeProps<StageNodeType>) {
	const { stage, canPromote, onPromote } = data;

	return (
		<div className="group stage-node">
			<Handle
				type="target"
				position={Position.Left}
				className="stage-node__handle"
			/>
			<div className="stage-node__header">
				<p className="stage-node__name">
					{stage.itemNumber && (
						<span className="stage-node__item">{stage.itemNumber}</span>
					)}
					<span>{stage.name}</span>
				</p>
				<div className="stage-node__actions">
					<StatusBadge status={stage.status} />
					{canPromote && stage.parentId && onPromote && (
						<Button
							variant="ghost"
							size="icon"
							className="nodrag stage-node__promote"
							aria-label={`Promover ${stage.name} a etapa raiz`}
							onClick={(event) => {
								event.stopPropagation();
								onPromote(stage.id);
							}}
						>
							<ArrowUpToLine />
						</Button>
					)}
				</div>
			</div>
			<Handle
				type="source"
				position={Position.Right}
				className="stage-node__handle"
			/>
		</div>
	);
}
